import React from 'react'
import { graphql } from 'react-apollo'
import { withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import { Paper, Modal, Typography } from 'material-ui'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import AssignmentIcon from 'material-ui-icons/Assignment'
import ChromeReaderModeIcon from 'material-ui-icons/ChromeReaderMode'
import AddIcon from 'material-ui-icons/Add'
import EditIcon from 'material-ui-icons/Edit'
import ClearIcon from 'material-ui-icons/Clear'
import DescriptionIcon from 'material-ui-icons/Description'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import CheckIcon from 'material-ui-icons/Check'
import LabelIcon from 'material-ui-icons/Label'
import { GC_USER_ID, GC_AUTH_TOKEN, ALABASTER, BOULDER } from '@/constants'
import GridList, { GridListTile } from 'material-ui/GridList'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import * as moment from 'moment'

import { READ_DATASETNAME, READ_DATASETS } from '@/graphql/queries/dataset'
import { CREATE_DATASET, UPDATE_DATASET } from '@/graphql/mutations/dataset'

import DateRangeIcon from 'material-ui-icons/DateRange'

import AlchemyProjectRoadmap from '@/components/ChartTypes/AlchemyProjectRoadmap'

const styles = theme => ({
  root: {
    width: '100%'
  },
  divText: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    paddingTop: 10,
    width: '100%'
  },
  linearColorPrimary: {},
  linearBarColorPrimary: {
    backgroundColor: 'rgba(80, 227, 194, .4)'
  },
  linearBarColorPrimaryComplete: {
    backgroundColor: 'rgba(144,238,144, .5)'
  },
  textFilter: {
    color: 'lightgrey',
    fontSize: 14,
    width: 340,
    fontWeight: 100,
    cursor: 'pointer'
  },
  textFilterGery: {
    color: 'grey',
    fontSize: 14,
    width: 340,
    fontWeight: 100,
    cursor: 'pointer'
  },
  activeSection: {
    backgroundColor: 'white',
    padding: 30
  },
  diableSection: {
    backgroundColor: '#f8f8f8',
    padding: 50
  },
  addSection: {
    backgroundColor: ALABASTER,
    padding: 25
  },
  iconSession: {
    color: 'rgba(0, 0, 0, .1)',
    width: 60,
    height: 60
  },
  iconSessionAdd: {
    color: 'rgba(0, 0, 0, .1)',
    width: 60,
    height: 60,
    paddingTop: 15
  },
  gridList: {
    width: '100%'
  },
  gridSubtitle: {
    color: BOULDER,
    lineHeight: 2
  },
  sessionBlock: {
    position: 'relative',
    textAlign: 'center',
    width: 93
  },
  paperBlock: {
    margin: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #dddddd',
    backgroundColor: 'rgba(222,184,135, .1)',
    height: 120,
    width: 93,
    cursor: 'pointer'
  },
  progressBar: {
    marginTop: -theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
    marginRight: theme.spacing.unit * 1
  },
  paperBlockAdd: {
    margin: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #dddddd',
    backgroundColor: 'white',
    height: 120,
    width: 93,
    cursor: 'pointer'
  },
  paperBlockAddNoCursor: {
    margin: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #dddddd',
    backgroundColor: 'white',
    height: 120,
    width: 93
  },
  icon: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  rootBottom: {
    height: 100,
    backgroundColor: ALABASTER,
    textAlign: 'left'
  },
  divAddModalButton: {
    textAlign: 'right',
    paddingRight: theme.spacing.unit * 1
  },
  iconBtnCheckAdd: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    marginBottom: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
    width: 24,
    height: 24
  },
  iconBtnCheck: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  iconEdit: {
    color: 'rgba(0, 0, 0, .1)',
    fontSize: 14
  },
  modalAddToday: {
    display: 'inline-block',
    overflow: 'scroll'
  },
  paperAddTodayMoreInfo: {
    boxShadow: '0px 0px 10px #eeeeee',
    width: '90%',
    marginLeft: '5%',
    marginTop: window.innerHeight * 0.05
  },
  divAddTpday: {
    position: 'relative',
    alignItems: 'center',
    width: '100%'
  },
  divClearButton: {
    textAlign: 'right',
    height: 26
  },
  iconClear: {
    color: 'rgba(0, 0, 0, .2)',
    fontSize: 26
  },
  modalContentDone: {
    height: 50,
    width: '100%',
    textAlign: 'left',
    backgroundColor: ALABASTER
  },
  divTodayPanelTitle: {
    textAlign: 'left',
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 4.5
  },
  paperCalendarView: {
    marginLeft: theme.spacing.unit * 4,
    marginRight: theme.spacing.unit * 4,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 4,
    padding: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #eeeeee',
    color: 'grey'
  }
})

@withApollo
@inject('resultMyProjects')
@inject('resultMyProjectsPref')
@observer
@graphql(CREATE_DATASET, { name: 'createDataSet' })
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@graphql(READ_DATASETNAME, {
  name: 'readMyProjectsDefault',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultMyProjects',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@graphql(READ_DATASETNAME, {
  name: 'readMyProjectsPreference',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultPreferenceMyProjects',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@graphql(READ_DATASETS)
@withStyles(styles)
export default class AlchemyMyProjects extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      statusSelected: 'Backlog',
      open: false,
      isEdit: false
    }
    this.handleAddProject = this.handleAddProject.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.chooseProject = this.chooseProject.bind(this)
  }

  handleFilterChange = filter => {
    this.setState({ statusSelected: filter })
  }

  chooseProject = session => {
    //('selected session: ' + session.projectName)
    var allDataPref = []
    const sessionSelected = {
      id: session.id,
      projectName: session.projectName,
      projectDescription: session.projectDescription,
      isCurrent: '1',
      date: session.date,
      dateComplete: session.dateComplete,
      status: session.status,
      tags: session.tags,
      issues: []
    }

    if (this.props.readMyProjectsPreference.loading) {
      return <div>Loading user session preference data ... </div>
    }

    if (this.props.resultMyProjectsPref.data.length === 0) {
      if (this.props.readMyProjectsPreference.allDataSets.length === 1) {
        if (
          this.props.readMyProjectsPreference.allDataSets[0].dataPoints !== ''
        ) {
          //('compare if seleted session exists')
          allDataPref = JSON.parse(
            this.props.readMyProjectsPreference.allDataSets[0].dataPoints
          )
          const selectedBefore = allDataPref.filter(b => b.id === session.id)
          if (selectedBefore.length === 0) {
            //('session is not selected before')
            //remove current from previous current
            const prevCurrent = allDataPref.filter(bo => bo.isCurrent === '1')
            if (prevCurrent.length === 1) {
              //('reset isCurrent')
              allDataPref[allDataPref.indexOf(prevCurrent[0])]['isCurrent'] =
                '0'
            }
            //add new session as current
            allDataPref.splice(0, 0, sessionSelected)
            this.props.resultMyProjectsPref.updateData(allDataPref)
            this.props.resultMyProjectsPref.updateSessionData(sessionSelected)
            this.updateDataPointsMyProjectsPref(JSON.stringify(allDataPref))
          } else if (selectedBefore.length === 1) {
            //('session is selected before')
          } else {
            return <div>error: session is duplicated, contact support</div>
          }
          //if session is there then change isCurrent and previous current session to be false
          //if session doesn't exist then add session info and isCurrent set to true
        }
      } else if (this.props.readMyProjectsPreference.allDataSets.length === 0) {
        allDataPref.splice(0, 0, sessionSelected)
        //('create defaultPreferenceMyProjects table')
        this.props.resultMyProjectsPref.updateData(allDataPref)
        this.props.resultMyProjectsPref.updateSessionData(sessionSelected)
        this.props.resultMyProjectsPref.updateCreated()
        this.createDataSetMyProjectsPref(JSON.stringify(allDataPref))
      } else {
        return (
          <div>
            Error, please contact our support team [readMyProjectsPreference:{' '}
            {this.props.readMyProjectsPreference.allDataSets.length}]
          </div>
        )
      }
    } else {
      //('compare if seleted session exists')
      allDataPref = this.props.resultMyProjectsPref.data
      const selectedBefore = allDataPref.filter(b => b.id === session.id)
      const prevCurrent = allDataPref.filter(bo => bo.isCurrent === '1')
      if (selectedBefore.length === 0) {
        //('session is not selected before')
        //remove current from previous current
        if (prevCurrent.length === 1) {
          //('reset isCurrent')
          allDataPref[allDataPref.indexOf(prevCurrent[0])]['isCurrent'] = '0'
        }
        allDataPref.splice(0, 0, sessionSelected)
        //add new session as current
        this.props.resultMyProjectsPref.updateData(allDataPref)
        this.props.resultMyProjectsPref.updateSessionData(sessionSelected)
        this.updateDataPointsMyProjectsPref(JSON.stringify(allDataPref))
      } else if (selectedBefore.length === 1) {
        //('session is selected before')
        if (prevCurrent.length === 1) {
          if (prevCurrent[0].id === session.id) {
            this.props.history.goBack()
            return
          }
          allDataPref[allDataPref.indexOf(prevCurrent[0])]['isCurrent'] = '0'
        }
        if (selectedBefore[0].id === session.id) {
          allDataPref[allDataPref.indexOf(selectedBefore[0])]['isCurrent'] = '1'
        }
        //add new session as current
        this.props.resultMyProjectsPref.updateData(allDataPref)
        this.props.resultMyProjectsPref.updateSessionData(sessionSelected)
        this.updateDataPointsMyProjectsPref(JSON.stringify(allDataPref))
      } else {
        //('error: session is duplicated, contact support')
      }
    }
  }

  handleAddProject = () => {
    //('adding new session')
    const num =
      this.props.resultMyProjects.data.length === 0
        ? 1
        : this.props.resultMyProjects.data[0].id + 1
    const newProject = {
      id: num,
      projectName: '',
      projectDescription: '',
      addedBy: global.localStorage.getItem(GC_USER_ID),
      addedAt: moment().format(),
      date: moment().format('l'),
      dateComplete: '',
      status: 'backlog',
      tags: ''
    }
    var allProjects = this.props.resultMyProjects.data
    allProjects.splice(0, 0, newProject)
    this.props.resultMyProjects.updateData(allProjects)
    this.props.resultMyProjects.updateSessionData(newProject)
    this.setState({ open: true })
  }

  handleCloseAddNo = () => {
    if (this.props.readMyProjectsDefault.allDataSets.length === 1) {
      if (this.props.readMyProjectsDefault.allDataSets[0].dataPoints !== '') {
        //('defualt session table is refreshed.')
        this.props.resultMyProjects.updateData(
          JSON.parse(this.props.readMyProjectsDefault.allDataSets[0].dataPoints)
        )
      }
    }
    this.setState({ open: false })
  }

  handleCloseAddYes = () => {
    this.props.resultMyProjects.data[0] = this.props.resultMyProjects.sessionData
    this.updateDataPoints(JSON.stringify(this.props.resultMyProjects.data))
    this.setState({ open: false })
  }

  handleCloseEdit = () => {
    this.props.resultMyProjects.updateDataBySession()
    this.updateDataPoints(JSON.stringify(this.props.resultMyProjects.data))
    this.setState({ open: false })
  }

  handleSessionEdit = id => {
    this.props.resultMyProjects.updateSessionDataById(id)
    this.setState({
      open: true,
      isEdit: true
    })
  }

  handleSessionDelete = id => {
    this.props.resultMyProjects.deleteSessionById(id)
    //update to dataset
    if (this.props.resultMyProjects.data.length === 0) {
      this.updateDataPoints(JSON.stringify([]))
    } else {
      this.updateDataPoints(JSON.stringify(this.props.resultMyProjects.data))
    }
    this.setState({ open: false })
  }

  updateDataPoints = async dataPoints => {
    if (this.props.readMyProjectsDefault.allDataSets.length === 0) {
      //('no default session data there')
      return
    }

    try {
      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.readMyProjectsDefault.allDataSets[0].id,
          dataPoints: dataPoints
        },
        update: () => {
          //('session data updated')
        }
      })
    } catch (e) {
      console.log('There is an error: ' + e)
      // todo: add data refresher to re-read database and give to result store
      this.signOut()
    }
  }

  signOut = () => {
    global.localStorage.removeItem(GC_USER_ID)
    global.localStorage.removeItem(GC_AUTH_TOKEN)
    this.props.history.push(`/login`)
  }

  updateDataPointsMyProjectsPref = async dataPoints => {
    if (this.props.readMyProjectsPreference.allDataSets.length === 0) {
      console.log('no default session data there')
      return
    }

    try {
      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.readMyProjectsPreference.allDataSets[0].id,
          dataPoints: dataPoints
        },
        update: () => {
          //('session data updated: readMyProjectsPreference')
          this.props.history.goBack()
        }
      })
    } catch (e) {
      console.log('There is an error: ' + e)
      // todo: add data refresher to re-read database and give to result store
      this.signOut()
    }
  }

  createDataSet = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/login`)
      return
    }
    // if default table is there, refuse to create
    if (this.props.readMyProjectsDefault.allDataSets.length > 0) {
      //('there is already default session table there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultMyProjects',
        description: 'defaultMyProjects',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        //('default session table created')
      }
    })
  }

  createDataSetMyProjectsPref = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/login`)
      return
    }
    // if default table is there, refuse to create
    if (this.props.readMyProjectsPreference.allDataSets.length > 0) {
      //('there is already default user session preference table there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultPreferenceMyProjects',
        description: 'defaultPreferenceMyProjects',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        //('default user session preference table created')
        this.props.resultMyProjectsPref.prefDatasetId = createDataSet.id
        this.props.history.goBack()
      }
    })
  }

  handleClose = () => {
    this.props.history.push('/')
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
    this.props.resultMyProjects.sessionData[name] = event.target.value
  }

  handleChangeProjectStatus = status => {
    this.props.resultMyProjects.sessionData.status = status
    this.props.resultMyProjects.updateDataBySession()
    this.updateDataPoints(JSON.stringify(this.props.resultMyProjects.data))

    this.setState({
      open: false
    })
  }

  render() {
    const { classes } = this.props
    const userId = global.localStorage.getItem(GC_USER_ID)

    //todo: add user login redirect
    if (!userId) {
      this.props.history.push(`/login`)
    }

    if (this.props.readMyProjectsDefault.loading) {
      return <div>Loading session data ... </div>
    }

    if (
      this.props.readMyProjectsDefault &&
      this.props.readMyProjectsDefault.error
    ) {
      return <div>Error</div>
    }

    if (
      this.props.resultMyProjects.data.length === 0 &&
      !this.props.resultMyProjects.created
    ) {
      if (this.props.readMyProjectsDefault.allDataSets.length === 1) {
        if (this.props.readMyProjectsDefault.allDataSets[0].dataPoints !== '') {
          //('defualt session table is there.')
          this.props.resultMyProjects.updateData(
            JSON.parse(
              this.props.readMyProjectsDefault.allDataSets[0].dataPoints
            )
          )
        }
      } else if (this.props.readMyProjectsDefault.allDataSets.length === 0) {
        //('defualt session table to be added')
        this.createDataSet(JSON.stringify(this.props.resultMyProjects.data))
        this.props.resultMyProjects.updateCreated()
      } else {
        return (
          <div>
            Error, please contact our support team [readMyProjectsDefault:{' '}
            {this.props.readMyProjectsDefault.allDataSets.length}]
          </div>
        )
      }
    }

    //get current sessions based on selected filter
    const openList = this.props.resultMyProjects.data.filter(
      b => b.status === 'open'
    )
    const closedList = this.props.resultMyProjects.data.filter(
      b => b.status === 'closed'
    )
    const backlogList = this.props.resultMyProjects.data.filter(
      b => b.status === 'backlog'
    )

    const noneList = []

    const projectData =
      this.state.statusSelected === 'Open'
        ? openList
        : this.state.statusSelected === 'Closed'
          ? closedList
          : this.state.statusSelected === 'Backlog' ? backlogList : noneList

    return (
      <div className={classes.root}>
        <Paper
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
            textAlign: 'center',
            boxShadow: '0px 0px 10px #eeeeee'
          }}
        >
          <List>
            <ListItem divider>
              <IconButton
                color="inherit"
                aria-label="Back"
                onClick={this.handleClose}
              >
                <ChevronLeftIcon />
              </IconButton>
              <ListItemText
                className={classes.modalHealder}
                primary={
                  <Typography
                    variant="body1"
                    style={{ fontSize: 18, color: 'grey' }}
                  >
                    What project would you like?
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <div className={classes.divText}>
                <Typography
                  onClick={() => this.handleFilterChange('Backlog')}
                  variant="caption"
                  className={
                    this.state.statusSelected === 'Backlog'
                      ? classes.textFilter
                      : classes.textFilterGery
                  }
                >
                  Backlog
                </Typography>
                <Typography
                  onClick={() => this.handleFilterChange('Open')}
                  variant="caption"
                  className={
                    this.state.statusSelected === 'Open'
                      ? classes.textFilter
                      : classes.textFilterGery
                  }
                >
                  Open
                </Typography>
                <Typography
                  onClick={() => this.handleFilterChange('Closed')}
                  variant="caption"
                  className={
                    this.state.statusSelected === 'Closed'
                      ? classes.textFilter
                      : classes.textFilterGery
                  }
                >
                  Closed
                </Typography>
                <Typography
                  onClick={() => this.handleFilterChange('Roadmap')}
                  variant="caption"
                  className={
                    this.state.statusSelected === 'Roadmap'
                      ? classes.textFilter
                      : classes.textFilterGery
                  }
                >
                  Roadmap
                </Typography>
              </div>
            </ListItem>
            {this.state.statusSelected !== 'Roadmap' && (
              <ListItem className={classes.activeSection}>
                <GridList className={classes.gridList} cols={3}>
                  <GridListTile xs={6} cols={1} key={'addnew'}>
                    {this.state.statusSelected === 'Backlog' ? (
                      <Paper
                        className={classes.paperBlockAdd}
                        onClick={this.handleAddProject}
                      >
                        <div id="sessionblock" className={classes.sessionBlock}>
                          <AddIcon className={classes.iconSessionAdd} />
                          <Typography
                            variant="body1"
                            id="projectName"
                            style={{
                              paddingLeft: 8,
                              paddingRight: 8,
                              paddingTop: 6,
                              textAlign: 'center'
                            }}
                          >
                            Add Project
                          </Typography>
                        </div>
                      </Paper>
                    ) : this.state.statusSelected === 'Open' ? (
                      <Paper className={classes.paperBlockAddNoCursor}>
                        <div id="sessionblock" className={classes.sessionBlock}>
                          <Typography
                            variant="body1"
                            id="projectName"
                            style={{
                              paddingLeft: 8,
                              paddingRight: 8,
                              paddingTop: 6,
                              textAlign: 'center',
                              color: 'lightgrey'
                            }}
                          >
                            {projectData.length === 0
                              ? "You haven't started any projects yet ..."
                              : 'Pick one and finish it ⇢'}
                          </Typography>
                        </div>
                      </Paper>
                    ) : this.state.statusSelected === 'Closed' ? (
                      <Paper className={classes.paperBlockAddNoCursor}>
                        <div id="sessionblock" className={classes.sessionBlock}>
                          <Typography
                            variant="body1"
                            id="projectName"
                            style={{
                              paddingLeft: 8,
                              paddingRight: 8,
                              paddingTop: 6,
                              textAlign: 'center',
                              color: 'lightgrey'
                            }}
                          >
                            {projectData.length === 0
                              ? "You haven't completed any projects yet ..."
                              : 'Re-start a completed project ⇢'}
                          </Typography>
                        </div>
                      </Paper>
                    ) : (
                      ''
                    )}
                  </GridListTile>
                  {projectData.map(bk => (
                    <GridListTile xs={6} cols={1} key={bk.id}>
                      <Paper
                        className={classes.paperBlock}
                        onClick={() => this.chooseProject(bk)}
                      >
                        <div id="sessionblock" className={classes.sessionBlock}>
                          <ChromeReaderModeIcon
                            className={classes.iconSession}
                          />
                          <Typography
                            variant="body1"
                            id="projectName"
                            style={{
                              paddingLeft: 8,
                              paddingRight: 2,
                              textAlign: 'left',
                              fontSize: 12,
                              color:
                                bk.tags === 'work'
                                  ? 'blue'
                                  : bk.tags === 'workout'
                                    ? 'orange'
                                    : bk.tags === 'tidyup'
                                      ? 'lightgreen'
                                      : bk.tags === 'internet'
                                        ? 'red'
                                        : bk.tags === 'family'
                                          ? 'pink'
                                          : bk.tags === 'planning'
                                            ? 'rgba(80, 227, 194, .6)'
                                            : bk.tags === 'eat'
                                              ? 'black'
                                              : bk.tags === 'chore'
                                                ? 'grey'
                                                : bk.tags === 'writing'
                                                  ? 'lightseagreen'
                                                  : bk.tags === 'love'
                                                    ? 'magenta'
                                                    : 'mediumpurple'
                            }}
                          >
                            {bk.projectName}
                          </Typography>
                          <Typography
                            variant="caption"
                            id="status"
                            style={{
                              paddingLeft: 8,
                              paddingRight: 8,
                              fontSize: 9,
                              textAlign: 'left'
                            }}
                          >
                            {bk.tags}
                          </Typography>
                        </div>
                      </Paper>
                      <div className={classes.divAddModalButton}>
                        <IconButton
                          className={classes.iconBtnCheckAdd}
                          onClick={() => this.handleSessionEdit(bk.id)}
                        >
                          <EditIcon className={classes.iconEdit} />
                        </IconButton>
                      </div>
                    </GridListTile>
                  ))}
                </GridList>
              </ListItem>
            )}
          </List>
        </Paper>
        {this.state.statusSelected === 'Roadmap' && (
          <div>
            <div className={classes.divTodayPanelTitle}>
              <Typography
                variant="caption"
                style={{ color: 'lightgrey', fontSize: 15 }}
              >
                Project Alchemy
              </Typography>{' '}
            </div>
            <Paper className={classes.paperCalendarView}>
              <AlchemyProjectRoadmap
                width={window.innerWidth}
                height={window.innerWidth * 0.76}
                data={this.props.resultMyProjects.data}
              />
            </Paper>
          </div>
        )}
        <List>
          <ListItem>
            <ListItemText />
            <Button color="inherit" onClick={this.handleClose}>
              <Typography
                variant="body1"
                style={{ fontSize: 18, color: 'grey' }}
              >
                Back
              </Typography>
            </Button>
          </ListItem>
        </List>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleCloseAddNo}
          className={classes.modalAddToday}
          disableBackdropClick
          disableAutoFocus
        >
          <Paper className={classes.paperAddTodayMoreInfo}>
            <div id="clearBtnBedTime" className={classes.divAddTpday}>
              <div className={classes.divClearButton}>
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleCloseAddNo}
                >
                  <ClearIcon className={classes.iconClear} />
                </IconButton>
              </div>
              <List>
                <ListItem divider>
                  <ListItemText
                    className={classes.modalHealder}
                    primary={'Project Information'}
                  />
                  {this.props.resultMyProjects.sessionData.status !==
                    'backlog' && (
                    <Button
                      color="inherit"
                      onClick={() => this.handleChangeProjectStatus('backlog')}
                      className={classes.iconBtnCheck}
                    >
                      <ChevronRightIcon
                        style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                      />
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        Backlog
                      </span>
                    </Button>
                  )}
                  {this.props.resultMyProjects.sessionData.status !==
                    'open' && (
                    <Button
                      color="inherit"
                      onClick={() => this.handleChangeProjectStatus('open')}
                      className={classes.iconBtnCheck}
                    >
                      <ChevronRightIcon
                        style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                      />
                      <span style={{ color: 'grey', fontSize: 15 }}>Open</span>
                    </Button>
                  )}
                  {this.props.resultMyProjects.sessionData.status !==
                    'closed' && (
                    <Button
                      color="inherit"
                      onClick={() => this.handleChangeProjectStatus('closed')}
                      className={classes.iconBtnCheck}
                    >
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        Complete
                      </span>
                      <CheckIcon
                        style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                      />
                    </Button>
                  )}
                </ListItem>
                <ListItem className={classes.modalContent}>
                  <ListItemIcon>
                    <AssignmentIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="projectName"
                    label="Project Name"
                    className={classes.textField}
                    value={this.props.resultMyProjects.sessionData.projectName}
                    onChange={this.handleChange('projectName')}
                    margin="normal"
                  />
                </ListItem>
                <ListItem className={classes.modalContentWhite}>
                  <ListItemIcon>
                    <DescriptionIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="projectDescription"
                    label="Project Description"
                    className={classes.textField}
                    value={
                      this.props.resultMyProjects.sessionData.projectDescription
                    }
                    onChange={this.handleChange('projectDescription')}
                    margin="normal"
                  />
                </ListItem>
                <ListItem className={classes.modalContentSmallTime}>
                  <ListItemIcon>
                    <DateRangeIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <TextField
                    id="date"
                    label="Start Date"
                    type="date"
                    defaultValue={moment(
                      new Date(this.props.resultMyProjects.sessionData.date),
                      'l'
                    ).format('YYYY-MM-DD')}
                    onChange={this.handleChange('date')}
                    className={classes.textFieldMedium}
                    InputLabelProps={{
                      className: classes.textFieldTimeTiny
                    }}
                    inputProps={{
                      className: classes.textFieldTimeSmall
                    }}
                  />
                  <ListItemIcon>
                    <DateRangeIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <form className={classes.container} noValidate>
                    <TextField
                      id="dateComplete"
                      label="End Date"
                      type="date"
                      defaultValue={
                        this.props.resultMyProjects.sessionData.dateComplete ===
                        ''
                          ? moment().format('YYYY-MM-DD')
                          : moment(
                              new Date(
                                this.props.resultMyProjects.sessionData.dateComplete
                              )
                            ).format('YYYY-MM-DD')
                      }
                      onChange={this.handleChange('dateComplete')}
                      className={classes.textFieldSmall}
                      InputLabelProps={{
                        shrink: true,
                        className: classes.textFieldTimeTiny
                      }}
                      inputProps={{
                        className: classes.textFieldTimeSmall
                      }}
                    />
                  </form>
                </ListItem>
                <ListItem className={classes.modalContentWhite}>
                  <ListItemIcon>
                    <LabelIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="tags"
                    label="tags"
                    className={classes.textField}
                    value={this.props.resultMyProjects.sessionData.tags}
                    onChange={this.handleChange('tags')}
                    margin="normal"
                  />
                </ListItem>
                {this.state.isEdit ? (
                  <ListItem className={classes.modalContentDone}>
                    <Button
                      color="inherit"
                      onClick={() =>
                        this.handleSessionDelete(
                          this.props.resultMyProjects.sessionData.id
                        )
                      }
                      className={classes.iconBtnCheck}
                    >
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        Delete
                      </span>
                    </Button>
                    <ListItemText />
                    <Button
                      color="inherit"
                      onClick={this.handleCloseEdit}
                      className={classes.iconBtnCheck}
                    >
                      <span style={{ color: 'grey', fontSize: 15 }}>Done</span>
                      <ChevronRightIcon
                        style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                      />
                    </Button>
                  </ListItem>
                ) : (
                  <ListItem className={classes.modalContentDone}>
                    <ListItemText />
                    <Button
                      color="inherit"
                      onClick={this.handleCloseAddYes}
                      className={classes.iconBtnCheck}
                    >
                      <Typography
                        variant="body1"
                        style={{ fontSize: 18, color: 'grey' }}
                      >
                        Add
                      </Typography>
                    </Button>
                  </ListItem>
                )}
              </List>
            </div>
          </Paper>
        </Modal>
      </div>
    )
  }
}

AlchemyMyProjects.propTypes = {
  classes: PropTypes.object
}

AlchemyMyProjects.defaultProps = {
  classes: {}
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/myProjects.js